<template> </template>

<script>
//import Baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import prepareTextArea from '@/components/riskAssessment/prepareTextArea.vue' //20220414 LYJ base page 추가
import prepareTitle from '@/components/riskAssessment/prepareTitle.vue'
export default {
  //extends: Baseview,
  name: 'BasePreparation',
  components: { prepareTextArea, prepareTitle },
  props: {
    saveAll: {
      type: Function,
      default: () => {}
    }
  },
  created() {
    this.$on('saveAll', () => {
      console.log('saveAll')
    })
  },
  methods: {
    setValue(key, value) {
      this.$store.dispatch('riskAssessmentRegualtions/changeValue', { key: key, value: value })
    },
    //MessageType: info, warn, error, question
    vToastify(body, messageType) {
      ////console.log({ title: title, body: body, popupType: 'confirm', messageType: messageType, useLoding: false })
      this.$EventBus.$emit('popupNotify', { body: body, popupType: 'confirm', messageType: messageType, useLoding: false })
    },
    vToastifyPrompt(body, messageType, yesAction, noAction, useLoding) {
      ////console.log({
      //   title: title,
      //   body: body,
      //   popupType: 'yesno',
      //   messageType: messageType,
      //   yesAction: yesAction,
      //   noAction: noAction,
      //   useLoding: useLoding
      // })
      this.$EventBus.$emit('popupNotify', {
        body: body,
        popupType: 'yesno',
        messageType: messageType,
        yesAction: yesAction,
        noAction: noAction,
        useLoding: useLoding
      })
    }
  }
}
</script>
